/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Details View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './detailsView';

export const mapStateToPropsDetailsView = mapStateToProps;
export const mapDispatchToPropsDetailsView = mapDispatchToProps;

export default connect(
  mapStateToPropsDetailsView,
  mapDispatchToPropsDetailsView
)(View);
